import Page from 'src/components/Page';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import React, { useEffect, useState } from "react";
import { Link as RouterLink } from 'react-router-dom';
import { Button, Container, Skeleton, Stack } from '@mui/material';
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import * as constants from 'src/utils/constants';
import { showErrorToast, showToast } from 'src/utils/Toast/SnackbarProvider';
import { debounce } from 'src/utils/debounceSearch';
import apiInstance from 'src/utils/apiAuth';
import { Send, Update } from '@mui/icons-material';
import axios from 'axios';
import { getDDMMYYYYFormat } from 'src/utils/commonUtils';

const theme = createTheme({
    components: {
        MUIDataTable: {
            styleOverrides: {
                root: {
                    backgroundColor: '#red',
                },
                paper: {
                    boxShadow: 'none',
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    // backgroundColor: 'yellow',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    backgroundColor: 'purple',
                },
            },
        },
        MUIDataTableHeadCell: {
            styleOverrides: {
                root: {
                    fontWeight: '700',
                },
                data: {
                    fontWeight: '700',
                }
            }
        },
        MUIDataTableSelectCell: {
            styleOverrides: {
                headerCell: {
                    // backgroundColor: 'blue',
                    fontWeight: '500px'
                },
            },
        },
        MuiTableFooter: {
            styleOverrides: {
                root: {
                    '& .MuiToolbar-root': {
                        //   backgroundColor: 'purple',
                    },
                },
            },
        },
    },
    typography: {
        fontFamily: "Lexend"
    }
});

const components = {
    ExpandButton: function (props) {
        return <ExpandButton {...props} />;
    }
};

const StyledButton = {
    backgroundColor: "#00AB55",
    fontFamily: "Public Sans,sans-serif",
    fontWeight: "700",
    borderRadius: "8px",
    boxShadow: "0 8px 16px 0 rgb(0 171 85 / 10%)"
}

export default function SenderDetails() {
    const [isLoading, setIsLoading] = useState(true)
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [count, setCount] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortOrder, setSortOrder] = useState();

    const debouncedSearch = debounce((query) => {
        setSearchQuery(query);
    }, 1000);

    const options = {
        selectableRows: "none",
        filter: false,
        filterType: "dropdown",
        responsive: "standard",
        draggableColumns: { enabled: true },
        print: false,
        download: false,
        page: currentPage,
        serverSide: true,
        count: count,
        rowsPerPage: rowsPerPage,
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setCurrentPage(tableState.page);
                    break;
                case 'changeRowsPerPage':
                    setRowsPerPage(tableState.rowsPerPage);
                    break;
                case 'search':
                    debouncedSearch(tableState.searchText);
                    break;
                case 'sort':
                    setSortOrder(tableState.sortOrder);
                    break;
                default:
                    break;
            }
        },
    };

    const columns = [
        {
            name: "id",
            label: "ID",
            options: {
                filter: false,
            },
        },
        {
            name: "email",
            label: "Email",
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    var id = tableMeta.rowData[0]
                    return (
                        <RouterLink
                            to={`/sender-details/edit/${id}`}
                            state={{ fromPage: "sender" }}
                            style={{
                                textDecoration: 'none',
                                color: '#00AB55',
                                fontWeight: 'bold'
                            }}>
                            {value}
                        </RouterLink>
                    )
                }
            }
        },
        {
            name: "sender_name",
            label: "Name",
            options: {
                filter: false,
            },
        },
        {
            name: "created_by",
            label: "Created by",
            options: {
                filter: false,
            },
        },
        {
            name: "is_active",
            label: "Active",
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (value)
                        return <CheckCircleIcon fontSize='medium' color='success' />
                    else
                        return <CancelIcon fontSize='medium' color='error' />
                }
            }
        },
        {
            name: "is_verified",
            label: "Verified",
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (value)
                        return <CheckCircleIcon fontSize='medium' color='success' />
                    else
                        return <CancelIcon fontSize='medium' color='error' />
                }
            }
        },
        {
            name: "actions",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => {
                    return  <Stack spacing={2} direction="row" justifyContent="center">
                                {value?.is_verified}
                                {value?.resend_verification}
                            </Stack>
                }
            }
        },
        {
            name: "created",
            label: "Created on",
            options: {
                filter: false,
                display: false,
                customBodyRender: (value) => {
                    return (
                        <p>{getDDMMYYYYFormat(value)}</p>
                    )
                }
            }
        },
    ];

    const [senderData, setSenderData] = useState([]);
    const getSenderData = (page, pageSize = 50, query = '', sortOrder = null) => {
        let apiUrl = `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/sender-details?`;
        if (query) apiUrl += `search=${query}&`;
        if (page + 1 && pageSize) apiUrl += `page=${page + 1}&page_size=${pageSize}&`;
        if (sortOrder && sortOrder?.name && sortOrder?.direction) apiUrl += `sortfield=${sortOrder.name}&sortdirection=${sortOrder.direction}&`

        if (apiUrl.endsWith("&")) apiUrl = apiUrl.slice(0, -1);

        apiInstance.get(apiUrl, { headers: { "Authorization": `Token ${localStorage.getItem('authToken')}` } })
            .then((response) => {
                setSenderData(response?.data?.results?.data);
                setCount(response?.data?.count || 0);
            })
            .catch((e) => showErrorToast(e))
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        getSenderData(currentPage, rowsPerPage, searchQuery, sortOrder);
    }, [currentPage, rowsPerPage, searchQuery, sortOrder])

    const callSenderDetailsUpdateAPI = (id) => {
        apiInstance({
            method: "put",
            url: "sender-details/" + id + "/",
            data: {"is_verified": true},
        })
            .then(function (response) {
                showToast(response.data.message);
                window.location.reload(false);
            })
            .catch(function (error) {
                showErrorToast(error);
            });
    }

    const [isRefreshing, setIsRefreshing] = useState(null);
    const isVerified = (id, sender_id) => {
        setIsRefreshing(id);
        let apiUrl = `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/sender-details/check-sender-verification?sender_id=${sender_id}`;
    
        axios.get(apiUrl, { headers: { "Authorization": `Token ${localStorage.getItem('authToken')}` } })
            .then((response) => {
                if (response?.data?.verified) {
                    callSenderDetailsUpdateAPI(id);
                }
            })
            .catch((error) => {
                showErrorToast(error, null, 5000);
            })
            .finally(() => {
                setIsRefreshing(null);
            });
    };

    const resendVerification = (sender_id) => {    
        let apiUrl = `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/sender-details/resend-verification/`;
        axios.post(
            apiUrl,
            { sender_id },  // Move sender_id to the request body
            {
                headers: {
                    "Authorization": `Token ${localStorage.getItem('authToken')}`
                }
            }
        )
        .then((response) => {
            showToast(response?.data?.message || "Verification request has been sent");
        })
        .catch((error) => {
            showErrorToast(error, null, 5000);
        });
    }

    return (
        <Page title="Sender Details | CRM">
            <Container maxWidth="xl">
                <h2 align="center" style={{ fontSize: '25px', fontWeight: '800', marginBottom: '30px' }}>Company Member Designation</h2>
                {isLoading ? (
                    <div style={{ padding: '16px', marginTop: "20px" }}>
                        {/* Skeleton for the Table Header */}
                        <div style={{ display: 'flex', marginBottom: '20px' }}>
                            {columns.map((column, colIndex) => (
                                <Skeleton
                                    key={colIndex}
                                    variant="text"
                                    width={'30%'}
                                    style={{ marginRight: '16px' }}
                                    height={50}
                                />
                            ))}
                        </div>
                        {/* Skeletons for the Table Rows */}
                        {Array.from(new Array(rowsPerPage)).map((_, rowIndex) => (
                            <div key={rowIndex} style={{ display: 'flex', marginBottom: '10px' }}>
                                {columns.map((column, colIndex) => (
                                    <Skeleton
                                        key={colIndex}
                                        variant="text"
                                        width={'30%'}
                                        style={{ marginRight: '16px' }}
                                        height={50}
                                    />
                                ))}
                            </div>
                        ))}
                    </div>
                ) : (
                    <ThemeProvider theme={theme}>
                        <MUIDataTable
                            title={
                                <Button
                                    variant="contained"
                                    component={RouterLink}
                                    to="/sender-details/add/"
                                    startIcon={<Icon icon={plusFill} />}
                                    style={StyledButton}
                                >
                                    Add Sender Details
                                </Button>
                            }
                            data={senderData?.slice(0)?.reverse()?.map(data => {
                                return {
                                    id: data?.id,
                                    email: data?.email,
                                    sender_name: data?.sender_name,
                                    is_active: data?.is_active,
                                    is_verified: data?.is_verified,
                                    created_by: data?.created_by?.first_name + " " + data?.created_by?.last_name,
                                    actions: {
                                        is_verified:   <Button
                                                            variant="outlined"
                                                            disabled={!data?.sender_id || data.is_verified || isRefreshing === data?.id}
                                                            onClick={() => isVerified(data?.id, data?.sender_id)}
                                                            startIcon={<Update />}
                                                            size='small'
                                                        >
                                                            Refresh
                                                        </Button>,
                                        resend_verification:    <Button 
                                                                    variant="outlined"
                                                                    disabled={!data?.sender_id || data.is_verified}
                                                                    onClick={() => resendVerification(data?.sender_id)}
                                                                    startIcon={<Send />}
                                                                    color='success'
                                                                    size='small'
                                                                >
                                                                    Resend Verification
                                                                </Button>
                                    },
                                    created: data?.created
                                }
                            })}
                            columns={columns}
                            options={options}
                            components={components}
                        />
                    </ThemeProvider>
                )}
            </Container>
        </Page>
    )
}